import Vue from 'vue'
import App from './App'
import router from './router'
import store from './Vuex/index'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './assets/css/index.css'
import './assets/js/mixin'
import api from './models/service'

Vue.use(Antd)
Vue.config.productionTip = false

function restoreSession () {
  if (sessionStorage.token || !localStorage.refresh_token || window.location.pathname === '/login') {
    return Promise.resolve(true)
  }

  return new Promise((resolve) => {
    api.OAuth(
      store.state.URLHost,
      { refresh_token: localStorage.refresh_token },
      (result) => {
        if (result.response === true && result.data.access_token) {
          sessionStorage.token = result.data.access_token
          resolve(true)
        } else {
          resolve(false)
        }
      },
      () => resolve(false)
    )
  })
}

async function bootstrap () {
  const authenticated = await restoreSession()

  // A newly opened tab has its own sessionStorage. Do not mount protected
  // pages until their access token has been restored, otherwise their
  // mounted hooks send `Bearer undefined` and briefly report Invalid Token.
  if (!authenticated) {
    localStorage.clear()
    sessionStorage.clear()
    if (window.location.pathname !== '/login') {
      window.location.replace('/login')
      return
    }
  }

  new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    render: (h) => h(App)
  })
}

bootstrap()



// WEBPACK FOOTER //
// ./src/main.js